export default "__VITE_ASSET__DtAE1Eno__"